package com.xtream.composeapp.presentation.ui.ad

 import androidx.compose.animation.core.FastOutSlowInEasing
 import androidx.compose.animation.core.animateFloatAsState
 import androidx.compose.animation.core.keyframes
 import androidx.compose.foundation.Image
 import androidx.compose.foundation.background
 import androidx.compose.foundation.border
 import androidx.compose.foundation.layout.Arrangement
 import androidx.compose.foundation.layout.Box
 import androidx.compose.foundation.layout.Column
 import androidx.compose.foundation.layout.PaddingValues
 import androidx.compose.foundation.layout.Row
 import androidx.compose.foundation.layout.Spacer
 import androidx.compose.foundation.layout.aspectRatio
 import androidx.compose.foundation.layout.calculateStartPadding
 import androidx.compose.foundation.layout.fillMaxWidth
 import androidx.compose.foundation.layout.padding
 import androidx.compose.foundation.layout.width
 import androidx.compose.material.icons.Icons
 import androidx.compose.material.icons.filled.Movie
 import androidx.compose.material3.MaterialTheme
 import androidx.compose.material3.Surface
 import androidx.compose.material3.Text
 import androidx.compose.runtime.Composable
 import androidx.compose.runtime.LaunchedEffect
 import androidx.compose.runtime.getValue
 import androidx.compose.runtime.mutableStateOf
 import androidx.compose.runtime.remember
 import androidx.compose.runtime.rememberCoroutineScope
 import androidx.compose.runtime.setValue
 import androidx.compose.ui.Modifier
 import androidx.compose.ui.draw.scale
 import androidx.compose.ui.graphics.ImageBitmap
 import androidx.compose.ui.graphics.painter.BitmapPainter
 import androidx.compose.ui.graphics.painter.Painter
 import androidx.compose.ui.graphics.vector.rememberVectorPainter
 import androidx.compose.ui.layout.ContentScale
 import androidx.compose.ui.platform.LocalDensity
 import androidx.compose.ui.platform.LocalLayoutDirection
 import androidx.compose.ui.platform.LocalWindowInfo
 import androidx.compose.ui.text.font.FontWeight
 import androidx.compose.ui.text.style.TextDecoration
 import androidx.compose.ui.unit.dp
 import androidx.compose.ui.unit.sp
 import androidx.compose.ui.window.Dialog
 import androidx.compose.ui.window.DialogProperties
 import androidx.lifecycle.compose.collectAsStateWithLifecycle
 import coil3.compose.AsyncImagePainter
 import coil3.compose.rememberConstraintsSizeResolver
 import com.kmpalette.palette.graphics.Palette
 import com.kmpalette.rememberPainterPaletteState
 import com.xtream.ui.platform.adaptiveValue
 import com.xtream.composeapp.presentation.widget.ContactInfoDialog
 import com.xtream.sharedResources.resources.Res
 import com.xtream.sharedResources.resources.close
 import com.xtream.sharedResources.resources.sponsored
 import com.xtream.sharedResources.resources.support_contact
 import com.xtream.data_kmp.dto.Ad
 import com.xtream.ui.ui.widget.NetworkImageCard
 import com.xtream.ui.ui.widget.TvButton
 import com.xtream.ui.ui.widget.Visibility
 import com.xtream.ui.ui.widget.rememberPlatformImagePainter
 import kotlinx.coroutines.Dispatchers
 import kotlinx.coroutines.launch
 import org.jetbrains.compose.resources.stringResource


@Composable
fun AdCard(ad: Ad, modifier: Modifier = Modifier, contentPadding: PaddingValues = PaddingValues(start = 16.dp),
           onBitmapLoaded: (( Palette) -> Unit)? = null){
    val currentLocale = "En"// LocalConfiguration.current.locales[0].language

    val layoutDirection = LocalLayoutDirection.current

    val title = ad.title?.localize(currentLocale)
    val description = ad.description?.localize(currentLocale)
    val image = ad.localizedImage(currentLocale)

    val aspectRatio = ad.aspect?.let {
        val numerator = it.numerator
        val denominator = it.denominator
        if (numerator != 0f && denominator != 0f) {
            denominator.div(numerator)
        } else {
            16f / 9f
        }
    } ?: (16f / 9f)

    val density = LocalDensity.current
      val screenWidth = with(density) {
        LocalWindowInfo.current.containerSize.width.toDp()
    }
    var showAdDialog by remember { mutableStateOf(false) }
    val scope = rememberCoroutineScope  ()

    // 1. Hook kmpalette into the full palette calculation state
    val paletteState = rememberPainterPaletteState()

    // 2. Manage the active mutable painter reference
    var currentPainter: Painter by remember {
        val emptyBitmap = ImageBitmap(width = 1, height = 1)
        mutableStateOf(BitmapPainter(emptyBitmap))
    }

    // 3. Whenever currentPainter is updated, re-generate the full palette
    LaunchedEffect(currentPainter) {
        scope.launch(Dispatchers.Default) {
            paletteState.generate(currentPainter)
        }
    }

    // 4. 🚀 Monitor the calculated palette state and send it upstream!
    LaunchedEffect(paletteState.palette) {
        paletteState.palette?.let { computedPalette ->
            onBitmapLoaded?.invoke(computedPalette)
        }
    }


    Text(stringResource(Res.string.sponsored), modifier= Modifier.padding(start = contentPadding.calculateStartPadding(layoutDirection), bottom = 8.dp, top= 4.dp))

    Box(
        modifier.padding(contentPadding)
    ){
        NetworkImageCard(
       // modifier = modifier.padding(contentPadding),
        width = screenWidth,
        src=image,
        title = title?:"",
        description = description,
        infoSectionVisibility = Visibility.VISIBLE_ALWAYS,
        focusedScale= 1f,
        //description = stream.name?:"",
        onClick = {
            showAdDialog = true
        },
        aspectRatio = aspectRatio,
        onBitmapLoaded = {
            currentPainter = it
        },
    )}

    AdDialog( show = showAdDialog,
        title = title?:"",
        description = description?:"",
        image = image?:"",
        discountedPrice = ad.discountNewPrice?:"",
        originalPrice = ad.oldPrice?:"",
        imageAspect = aspectRatio, onDismiss = {
            showAdDialog = false
        })
}





@Composable
fun AdDialog(show: Boolean = true,
             title: String,
             description: String,
             image: String,
             imageAspect: Float,
             discountedPrice: String ,
             originalPrice: String,
             onDismiss: () -> Unit = {}) {

    val usePlatformWidth = adaptiveValue(
        compactValue = true,
        expandedValue = false,
        default = false
    )

    var showContactDialog by remember { mutableStateOf(false) }

    ContactInfoDialog(
        showContactDialog,
        onDismiss = {
            showContactDialog = false
        }

    )

    if(show)
        Dialog(
            onDismissRequest = onDismiss,
            properties = DialogProperties(
                usePlatformDefaultWidth = usePlatformWidth
            )
        ) {
            val sizeResolver = rememberConstraintsSizeResolver()
            val painter=rememberPlatformImagePainter(image, sizeResolver)
            val state by painter.state.collectAsStateWithLifecycle()


            Surface(
                shape = MaterialTheme.shapes.medium,
                color = MaterialTheme.colorScheme.background,
                tonalElevation = 8.dp, // optional
                modifier = Modifier
                    .then(
                        if (usePlatformWidth)
                            Modifier
                        else
                            Modifier.fillMaxWidth(.6f)
                    )



                    .border(
                        width = .5.dp,
                        color = MaterialTheme.colorScheme.onBackground.copy(alpha = .2f),
                        shape = MaterialTheme.shapes.medium
                    )

            // add padding so shape is visible
            ) {
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                ) {
                    Image(
                        modifier = Modifier
                                .fillMaxWidth()
                            .aspectRatio(imageAspect)
                            .then(sizeResolver)

                        ,
                        painter= when(state){
                            is AsyncImagePainter.State.Success -> painter
                            else -> {
                                rememberVectorPainter(Icons.Default.Movie)
                            }
                        },
                        contentDescription = title,
                        contentScale = ContentScale.Crop,


                        )

                    Text(
                        text = title,
                        style = MaterialTheme.typography.titleLarge.copy(
                            lineHeight = 24.sp // Set line height explicitly

                        ),
                        modifier = Modifier.padding(16.dp),

                    )
                    PriceChips( discountedPrice = discountedPrice, originalPrice = originalPrice )
                    Text(
                        text = description,
                        style = MaterialTheme.typography.bodyLarge.copy(
                            fontWeight  = FontWeight.Normal
                        ),
                        modifier = Modifier.padding(16.dp)
                    )

                    Row(
                        modifier = Modifier
                            .padding(bottom = 24.dp, top = 48.dp)
                            .padding(horizontal = 24.dp),
                        horizontalArrangement = Arrangement.spacedBy(16.dp)
                    ){
                        TvButton(stringResource(Res.string.close),

                        ) {
                            onDismiss()
                        }
                        TvButton(stringResource(Res.string.support_contact),

                        ) {
                            onDismiss()
                            showContactDialog = true
                        }
                    }

                }

            }}

}

@Composable
fun PriceChips(
    discountedPrice: String,
    originalPrice: String
) {





    var animate by remember { mutableStateOf(false) }

    val scale by animateFloatAsState(
        targetValue = if (animate) 1f else 1.1f,
        animationSpec = keyframes {
            durationMillis = 2000
            1.15f at 250 using FastOutSlowInEasing
            1f at 500 using FastOutSlowInEasing
            1f at 2000
        }
    )

    LaunchedEffect(Unit) {
        animate = true // triggers animation from 1.15f to 1f
    }






    Row(
        horizontalArrangement = Arrangement.spacedBy(8.dp),
        modifier = Modifier.padding(horizontal = 16.dp)
    ) {
        // Original Price Chip with strikethrough

        Text(
            modifier = Modifier
                .padding(4.dp),
            text = originalPrice,
            style = MaterialTheme.typography.titleMedium,
            textDecoration = TextDecoration.LineThrough,
            color = MaterialTheme.colorScheme.onBackground,

            )
        // Discounted Price Chip

        Spacer(modifier =
            Modifier
                .width(1.dp)
                .background(MaterialTheme.colorScheme.onBackground)
                .padding(horizontal = 4.dp)
        )
                Text(
                    modifier = Modifier
                        .padding(4.dp)
                        .scale(scale)
                        ,
                    text = discountedPrice,
                    style = MaterialTheme.typography.titleMedium,
                    color = MaterialTheme.colorScheme.onBackground,
                )




    }
}

